import React, { useRef, useState } from 'react';
import { Tooltip as ReactTooltip } from 'reactstrap';

import ic_copy_message from "assets/images/ic_copy_message.svg";

import "assets/scss/components/informational/tooltip.scss";
import { Toaster } from 'components/notification/Toaster';
import { getStringUniqueId } from 'functions';

export function Tooltip(props) {
    const {
        className, targetClassName,
        targetContentClassName,
        target, tooltipContent,
        placement, type,
        isCopyTargetTextRequired
    } = props;

    // handle tooltip type decoration
    let decorationType = "";
    switch (type) {
        case "light":
            decorationType = "tooltip_light-decoration";
            break;
    }

    const [id] = useState(getStringUniqueId("tooltip"));
    const [targetContentId] = useState(getStringUniqueId("tooltip-target-content"));
    const isScrolling = useRef(false);
    const [isVisible, setIsVisible] = useState(false);
    
    function copyContent() {
        let targetContentEle = document.getElementById(targetContentId);
        let tempTextArea = document.createElement("TEXTAREA");
        tempTextArea.value = targetContentEle.innerHTML;

        document.body.appendChild(tempTextArea);
        tempTextArea.select();
        document.execCommand("copy");
        document.body.removeChild(tempTextArea);

        Toaster({
            type: "success",
            msg: "Copied!"
        })
    }

    function onTooltipVisible() {
        let tooltip = document.getElementById(id);

        if (tooltip && (tooltip.scrollTop != (tooltip.scrollHeight - tooltip.clientHeight)) &&
            isScrolling.current) {
            
            if (tooltip.scrollTop == 0) 
                setTimeout(onTooltipVisible, 5000);
            else setTimeout(onTooltipVisible, 150);

            tooltip.scrollBy(0,1);
        }
    }

    function onTooltipHidden() {
        let tooltip = document.getElementById(id);
        if (tooltip) tooltip.scrollTop = 0;
    }

    return (
        <div className={"component-tooltip " +
                (className? className + " ":"")}>
            <div data-tip data-for={id} 
                className={"component-tooltip__target d-flex align-items-center " + 
                    (targetClassName? targetClassName + " ":"")}
            >
                <div id={targetContentId} className={"target__content " +
                        (targetContentClassName? targetContentClassName + " ":"")}
                    onMouseEnter={() => {
                        isScrolling.current = true;
                        onTooltipVisible();
                        setIsVisible(true);
                    }}
                    onMouseLeave={() => {
                        isScrolling.current = false;
                        onTooltipHidden();
                        setIsVisible(false);
                    }}
                >
                    {target}
                </div>
                
                {isCopyTargetTextRequired? (
                    <div className={"target__copy-content"}>
                        <img
                            className={"copy-content__icon"}
                            src={ic_copy_message}
                            onClick={copyContent}
                        />
                    </div>
                ):""}
            </div>

            <ReactTooltip 
                className={"component-tooltip__tooltip "}
                innerClassName={"tooltip__content " +
                    (decorationType? decorationType:"")}
                placement={placement? placement:"bottom"} isOpen={isVisible} target={targetContentId}

                arrowClassName={"tooltip__arrow " +
                (decorationType? decorationType:"")}
                hideArrow
            >
                
                <div  id={id}>
                    {tooltipContent}
                </div>
            </ReactTooltip>
        </div>
    );
}